import { Box, Paper, Skeleton } from '@mui/material'
import React from 'react'
import "./style.css";
import CustomTypography from 'components/Fileds/CustomTypography';

const SummaryCard = ({ item, theme, isSmall, height, isLoading }) => {
  if (isLoading) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: isSmall ? 1 : 2,
          height: isSmall ? height ? height : "50px" : height ? height : "55px",
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '4px'
        }}
        className="order-summary-item"
      >
        <Skeleton variant="text" width="70%" height={18} animation="wave" />
        <Skeleton variant="text" width="40%" height={24} animation="wave" />
      </Paper>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: isSmall ? 1 : 2,
        height: isSmall ? height ? height : "50px" : height ? height : "55px",
      }}
      className="order-summary-item"
    >
      <Box className='d-flex align-items-center'>
        <CustomTypography component={"div"}
          label={item?.title}
          sx={{
            fontWeight: '600',
            fontSize: isSmall ? "12px" : "14px",
            mb: 0,
            color: theme.palette.typographyLabel.main
          }}
        >
        </CustomTypography>
        {item?.subtitle && (
          <CustomTypography variant="caption" color="text.secondary"
            label={item?.subtitle}
            sx={{
              marginLeft: '4px',
              mb: 0,
              lineHeight: "0",
            }}
          />
        )}
      </Box>
      <CustomTypography
        variant={"h6"}
        component={"div"}
        label={item?.value}
        sx={{
          color: item.highlight ? theme.palette.highlight.main : theme.palette.text.primary,
          fontSize: isSmall ? "1rem" : "18px",
          fontWeight: 'bold',
          mb: 0
        }}
      />
    </Paper>
  )
}

export default SummaryCard
